import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import { ROUTE_DATA_PATH } from '../../../../config/paths';
import RouteDataBasicInformationResource from './resource/RouteDataBasicInformationResource';
import {
  clearRouteData,
  getRouteData,
} from '../../../../actions/route/routeData';
import RouteDataToolbar from './RouteDataToolbar';

export const RouteData = ({
  breadcrumbs,
  dispatchGetRouteData,
  dispatchClearRouteData,
  match: {
    params: { id: routeDataId },
  },
  loading,
  routeData,
}) => {
  useLayoutEffect(() => {
    dispatchGetRouteData({ routeDataId });

    return () => dispatchClearRouteData();
  }, []);

  let content;

  let toolbar;

  if (loading) content = <Loader />;
  else if (routeData.isEmpty())
    content = <NoDataResource returnPage={ROUTE_DATA_PATH} />;
  else {
    const routeDataJson = routeData.toJS();

    content = <RouteDataBasicInformationResource {...routeDataJson} />;

    toolbar = <RouteDataToolbar fileUrl={routeDataJson.fileUrl} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Exportación de Datos de Ruta"
      content={content}
      toolbar={toolbar}
    />
  );
};

RouteData.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearRouteData: PropTypes.func.isRequired,
  dispatchGetRouteData: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  routeData: PropTypes.instanceOf(Immutable.Map).isRequired,
};

RouteData.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearRouteData: clearRouteData,
  dispatchGetRouteData: getRouteData,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Exportaciones de Rutas',
      href: ROUTE_DATA_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  routeData: RouteUnit.RouteData.getIn(['current', 'content']),
  loading: !RouteUnit.RouteData.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteData);
